<template>
    <div>
        <el-dialog title="依赖查询" width="80%"
        :visible="visible"
        @close="cancel"
        >
            <el-row>
                <h3>实例基本信息</h3>
                    <el-col :span="7">
                        <b>ID</b>:{{instanceInfo.id}}
                    </el-col>
                    <el-col :span="9">
                        <b>服务名称</b>:{{instanceInfo.name}}
                    </el-col>
                    <el-col :span="8">
                        <b>集成</b>:{{instanceInfo.integrationVersionAlias}}
                    </el-col>
                    <el-col :span="7">
                        <b>模块类型</b>:{{instanceInfo.moduleType}}
                    </el-col>
                    <el-col :span="9">
                        <b>模块版本</b>:{{instanceInfo.moduleVersion}}
                    </el-col>
                    <el-col :span="8">
                        <b>设备名称</b>:{{instanceInfo.deviceName}}
                    </el-col>
            </el-row>
            <el-row>
                <h3>依赖该模块类型的模块</h3>
                    <module-type-ele :tags="moduleTypes" :isDisplay="true"/>
            </el-row>
            <el-row>
                <h3>依赖该实例的实例</h3>
                <el-table :data="dependedList">
                    <el-table-column align="center" prop="id" label="实例ID"></el-table-column>
                    <el-table-column align="center" prop="moduleType" label="模块类型"></el-table-column>
                    <el-table-column align="center" prop="moduleVersion" label="模块版本"></el-table-column>
                </el-table>
            </el-row>
            <el-row style="text-align: center;margin-top:20px;">
                <el-button @click="cancel" size="mini">关闭</el-button>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import ModuleTypeEle from './ModuleTypeEle.vue'
export default {
    components: { ModuleTypeEle },
    props:{
        visible: {
            type: Boolean
        },
        instanceInfo:{
            type: Object,
            default: ()=>{
                return {}
            }
        }
    },
    data: vm=>({
        moduleTypes: [],
        dependedList: []
    }),
    created(){
        if(this.instanceInfo.id){
            this.getAllInstanceDepende()
        }
        if(this.instanceInfo.moduleType){
            this.getModuleDepend(this.instanceInfo.moduleType)
        }
    },
    methods: {
        // 查询依赖该模块的所有模块
        getModuleDepend(moduleType){
            this.$axios.get(this.moduleResourceUrl + 'module/resource/get/dependency/'+moduleType)
            .then(({ data: { msg, data, code } }) =>{
                if(code == 20000){
                    if(data.beDependencies){
                        const _this = this
                        data.beDependencies.forEach(beDepend => {
                            _this.moduleTypes.push({
                                name: beDepend,
                                selected:true
                            })
                        })
                    }
                }else{
                    this.$message.error(msg)
                }
            })
            .catch(err =>{
                console.log(err);
            })
        },
        // 查询所有依赖该实例的实例
        getAllInstanceDepende(){
            this.$axios
                .get(this.baseUrl3 + "instance/findByDependency/" + this.instanceInfo.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.dependedList = data ? data : []
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(err =>{
                    console.log(err);
                });
        },
        cancel(){
            this.$emit('closeDependencyDetail')
        }
    }
}
</script>
<style scoped>

</style>
